import { Box } from '@mui/material';

import { Typography } from '@occc-app/design-system';
import config from '@occc/config';

import phone from '../assets/phone.svg';

type MpaSimulatorProps = {
  locationId: string;
};

const MpaSimulator = ({ locationId }: MpaSimulatorProps) => {
  const experienceUrl = config.experienceUrl ? encodeURI(config.experienceUrl) : '';

  return (
    <Box>
      {experienceUrl ? (
        <Box width='38vh' position='relative' m='0 auto'>
          <Box component='img' height='75vh' minHeight={400} width='38vh' src={phone} alt='phone' />
          <Box position='absolute' top='8vh' left='2vh' width='34vh' height='59vh'>
            <iframe
              src={`${experienceUrl}?locationId=${locationId}`}
              title='Mobile Payment Application'
              frameBorder='0'
              scrolling='no'
              width='100%'
              height='100%'
            />
          </Box>
        </Box>
      ) : (
        <Typography color='textPrimary'>Preview not configured or OCX app not used.</Typography>
      )}
    </Box>
  );
};

export default MpaSimulator;
